@import 'styles/mixins';
@import 'styles/variables';
@import 'styles/blaze/mixins';

.container {
  width: 100%;
}

.header {
  @include xs-sohne-medium;
  margin-bottom: 5px;
}

.usageRow {
  @include sm-sohne;
  border-top: 1px solid var(--dark-4);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 7px 0;
}

.usageRowLeft {
  display: flex;
  align-items: center;
}

.usageRowRight {
  color: var(--dark-40);
}

.usageIconContainer {
  margin-right: 11px;
  height: 20px;
  color: var(--plan-color);
}

.bold {
  font-family: Sohne;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 135%; /* 18.9px */
  letter-spacing: 0.42px;
  color: var(--dark-80);
}
